import { PDFDocument } from 'pdf-lib';
import { encodeCanvas } from '../shared/imageOutputFormats';
import { imageDataToCanvas } from './documentCleanupEngine';

/** A4 in points — the sheet a multi-page export is laid out on. */
const A4 = { width: 595.28, height: 841.89 };

/**
 * The whole job as ONE PDF, a page per sheet (`results` = the finished pages as ImageData, in order).
 *
 * Each page is drawn onto A4 at the largest size that fits — a scan of a receipt and a scan of a full page then print at their own
 * proportions instead of being stretched to the paper. Shared by Document Cleanup and Document Print.
 */
export async function buildPagesPdf(results) {
    const pdf = await PDFDocument.create();
    for (const result of results) {
        const { blob } = await encodeCanvas(imageDataToCanvas(result), 'jpg', { quality: 0.92 });
        const embedded = await pdf.embedJpg(new Uint8Array(await blob.arrayBuffer()));
        const sheet = pdf.addPage([A4.width, A4.height]);
        const margin = 24;
        const scale = Math.min(
            (A4.width - margin * 2) / embedded.width,
            (A4.height - margin * 2) / embedded.height,
        );
        const w = embedded.width * scale;
        const h = embedded.height * scale;
        sheet.drawImage(embedded, {
            x: (A4.width - w) / 2,
            y: (A4.height - h) / 2,
            width: w,
            height: h,
        });
    }
    return new Blob([await pdf.save()], { type: 'application/pdf' });
}
